import { useNavigate } from '@solidjs/router';
import { useSubscription } from '@state/subscription';
import { useAuth } from '@stateApp';
import dayjs from 'dayjs';
import { type ParentComponent, onMount } from 'solid-js';
import { useService } from 'solid-services';

const OnboardingRedirect: ParentComponent = (props) => {
  const navigate = useNavigate();
  const { profilePrivate } = useService(useAuth)()
  const { subscription } = useService(useSubscription)()

  // Assuming these will eventually come from props or the profile signal
  // For now, keeping them as constants per your snippet
  const isFirstLogin = false
  const hasAcceptedTerms = true

  // TODO make this dynamic so that when route changes occur it will listen if the user is not approved,
  // Perhaps i can switch the logic to an early return for active users
  onMount(() => {
    // Unwrap the signal once to check values
    const currentProfile = profilePrivate();

    const redirectToJoin = currentProfile?.status === 'approved'
    const redirectToWelcome = currentProfile?.onboarded_at === null
    const redirectToTerms = currentProfile?.status === 'active' && !hasAcceptedTerms

    // Execute redirects based on priority
    if (redirectToJoin) {
      navigate('/onboarding', { replace: true });
      return;
    }

    if (redirectToWelcome) {
      navigate('/onboarding/welcome', { replace: true });
      return;
    }

    if (redirectToTerms) {
      navigate('/onboarding/terms', { replace: true });
      return;
    }

    // Access denied status checks
    if (subscription.data?.status === 'on-hold') {
      navigate('/status/on-hold', { replace: true });
      return;
    }

    if (subscription.data?.status === 'past-due') {
      navigate('/status/past-due', { replace: true });
      return;
    }

    if (subscription.data?.status === 'cancelled') {
      navigate('/status/cancelled', { replace: true });
      return;
    }

    const firstYearExpired = dayjs().isAfter(dayjs(subscription.data?.current_period_end));
    if (subscription.data?.is_first_year && firstYearExpired) {
      navigate('/status/subscribe', { replace: true });
      return;
    }

    if (subscription.data?.status === 'expired') {
      navigate('/status/expired', { replace: true });
      return;
    }

  })

  return <>
    {props.children}
  </>
}

export default OnboardingRedirect;
